import styled, { css } from 'styled-components';

// If set to `true`, AppWrapper will remove "overflow-y: auto;"
// and set both axis to "hidden". Default is `false`:
type AppWrapperAttributes = {
  $overflow?: boolean;
};

export const AppWrapper = styled.div<AppWrapperAttributes>(
  ({ $overflow }) => css`
    background-image: linear-gradient(rgb(187 187 187), rgb(34 34 34));

    overflow: hidden auto;
    min-height: 100dvh;
    position: relative;

    display: block;
    width: 100%;

    ${$overflow &&
    css`
      overflow: hidden;
    `}
  `
);

// If set to `false`, ContentWrapper will use full
// screen width on tablet devices. Default is `true`:
type ContentWrapperAttributes = {
  $clamp?: boolean;
};

export const ContentWrapper = styled.div<ContentWrapperAttributes>(
  ({ $clamp = true }) => css`
    min-height: 100dvh;
    position: relative;

    margin: 0px auto;
    display: block;

    height: 100%;
    width: 100%;

    ${$clamp &&
    css`
      max-width: ${Screen.MAX};
    `}
  `
);

export const ScreenWrapper = styled.section`
  justify-content: center;
  flex-direction: column;

  align-items: center;
  position: relative;

  min-height: 100dvh;
  max-width: 100vw;

  margin: 0 auto;
  display: flex;

  height: 100%;
  width: 100%;
`;

export enum Screen {
  // Portrait:
  MIN = '320px',
  MAX = '430px'

  // Landscape:
  // MIN = '568px',
  // MAX = '932px'
}

export enum zIndex {
  MIN = -2147483648,
  MAX = 2147483647
}
